import { render, staticRenderFns } from "./PosInventoryEdit.vue?vue&type=template&id=41ba5fd2&scoped=true&"
import script from "./PosInventoryEdit.vue?vue&type=script&lang=js&"
export * from "./PosInventoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba5fd2",
  null
  
)

export default component.exports